(function () {
  const STORAGE_KEY = 'theme:wishlist';

  function readWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      // localStorage unavailable (private mode, storage full, etc.) - state just won't persist
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles } }));
  }

  window.WishlistStore = {
    get() {
      return readWishlist();
    },
    has(handle) {
      return readWishlist().indexOf(handle) > -1;
    },
    toggle(handle) {
      const handles = readWishlist();
      const index = handles.indexOf(handle);
      if (index > -1) {
        handles.splice(index, 1);
      } else {
        handles.push(handle);
      }
      writeWishlist(handles);
      return handles.indexOf(handle) > -1;
    },
    remove(handle) {
      writeWishlist(readWishlist().filter((item) => item !== handle));
    },
  };

  if (!customElements.get('wishlist-button')) {
    customElements.define(
      'wishlist-button',
      class WishlistButton extends HTMLElement {
        connectedCallback() {
          this.handle = this.dataset.productHandle;
          this.button = this.querySelector('button');
          if (!this.button || !this.handle) return;

          this.onUpdate = this.render.bind(this);
          this.render();
          this.button.addEventListener('click', this.onClick.bind(this));
          document.addEventListener('wishlist:updated', this.onUpdate);
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:updated', this.onUpdate);
        }

        onClick(event) {
          event.preventDefault();

          if (!window.customerLoggedIn) {
            const loginUrl = (window.routes && window.routes.account_login_url) || '/account/login';
            const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
            window.location.href = `${loginUrl}?return_url=${returnTo}`;
            return;
          }

          window.WishlistStore.toggle(this.handle);
        }

        render() {
          const active = window.WishlistStore.has(this.handle);
          this.button.classList.toggle('is-active', active);
          this.button.setAttribute('aria-pressed', active);
          const label = active ? this.button.dataset.labelRemove : this.button.dataset.labelAdd;
          if (label) this.button.setAttribute('aria-label', label);
        }
      }
    );
  }

  if (!customElements.get('wishlist-count')) {
    customElements.define(
      'wishlist-count',
      class WishlistCount extends HTMLElement {
        connectedCallback() {
          this.onUpdate = this.render.bind(this);
          this.render();
          document.addEventListener('wishlist:updated', this.onUpdate);
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:updated', this.onUpdate);
        }

        render() {
          const count = window.WishlistStore.get().length;
          this.textContent = count;
          this.classList.toggle('hidden', count === 0);
        }
      }
    );
  }

  if (!customElements.get('wishlist-list')) {
    customElements.define(
      'wishlist-list',
      class WishlistList extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-wishlist-grid]');
          this.emptyState = this.querySelector('[data-wishlist-empty]');
          this.onUpdate = this.render.bind(this);
          this.render();
          document.addEventListener('wishlist:updated', this.onUpdate);
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:updated', this.onUpdate);
        }

        async render() {
          const handles = window.WishlistStore.get();

          if (handles.length === 0) {
            this.grid.innerHTML = '';
            this.emptyState.classList.remove('hidden');
            return;
          }

          this.emptyState.classList.add('hidden');

          const cardsHtml = await Promise.all(
            handles.map((handle) =>
              fetch(`/products/${handle}?section_id=product-card-ajax`)
                .then((response) => (response.ok ? response.text() : ''))
                .catch(() => '')
            )
          );

          this.grid.innerHTML = cardsHtml
            .filter(Boolean)
            .map((html) => `<li class="grid__item">${html}</li>`)
            .join('');
        }
      }
    );
  }
})();
